/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import cn from "classnames";

const ActiveFieldBar = (props) => {

    const activeFieldName = props?.activeFieldName;
    const activeFieldOptions = props?.activeFieldOptions;
    const handleSelectField = props?.handleSelectField;
    const isDisabled = props?.isDisabled;
    const activeFieldValue = activeFieldOptions?.some((option) => option.name === activeFieldName)
        ? activeFieldName
        : "";

    return (
        <div className={cn("active-field-bar", { "disabled": isDisabled })}>
            <div className='active-field-label'>
                Active Field
            </div>
            <FormControl
                className='active-field-select-container'
                fullWidth size='small'
            >
                {isDisabled &&
                    <InputLabel id='active-field-disabled-label' shrink={false}>
                        N/A
                    </InputLabel>
                }
                <Select
                    disableUnderline
                    disabled={isDisabled}
                    id='active-field-disabled-label'
                    label={isDisabled ? "N/A" : ""}
                    onChange={handleSelectField}
                    value={activeFieldValue}
                    variant='standard'
                >
                    {!isDisabled && activeFieldOptions?.map((field) => (
                        <MenuItem
                            key={`active-field-${field.name}`}
                            value={field.name}
                        >
                            {field.settings.label}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </div>
    );
};

export { ActiveFieldBar };
